<div class="grid grid-cols-12 gap-4">
  <div class="col-span-12 text-data">
    <h2>MicroAgent Configuration</h2>
    <label
      >Manage each MicroAgent configuration for this device and view the statuses and training/predicting progress for model-based
      configurations.</label
    >
  </div>
  <div class="col-span-12">
    <microsec-card [isNestedCard]="true" [isTableCard]="true">
      <microsec-common-table
        [dataKey]="'id'"
        [selectable]="false"
        [cols]="cols"
        [values]="values"
        [loading]="isLoading"
        [scrollHeight]="'30rem'"
        [paginator]="false"
        [cellTemplate]="cellTemplate"
        [actionsMenuItems]="actionsMenuItems"
        [containerHeaderRightTemplate]="rightTemplate" />

      <ng-template #rightTemplate>
        <microsec-refresh-button (refreshEvent)="getDeviceConfiguration()" />
      </ng-template>

      <ng-template let-col="col" let-rowData="rowData" #cellTemplate>
        <ng-container [ngSwitch]="col.field">
          <!-- Status -->
          <ng-container *ngSwitchCase="'status'">
            <div class="overflow-hidden whitespace-nowrap text-ellipsis">
              {{ rowData[col.field] | titlecase }}
            </div>
          </ng-container>
          <!-- Enabled -->
          <ng-container *ngSwitchCase="'enabled'">
            <p-checkbox [(ngModel)]="rowData[col.field]" [binary]="true" (ngModelChange)="handleToggleEnable($event, rowData)"></p-checkbox>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <div class="overflow-hidden whitespace-nowrap text-ellipsis">
              {{ rowData[col.field] || '-' }}
            </div>
          </ng-container>
        </ng-container>
      </ng-template>
    </microsec-card>
  </div>
</div>
